var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 216,
    preserveAspectRatio: "none",
    viewBox: "0 0 312 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "pizza-bg-part",
    d: "M8 7.85454C8 7.85454 82.6146 0 156 0C229.385 0 304 7.85454 304 7.85454C304 7.85454 312 64.4495 312 108C312 151.551 304 208.145 304 208.145C304 208.145 229.385 216 156 216C82.6146 216 8 208.145 8 208.145C8 208.145 0 151.551 0 108C0 64.4495 8 7.85454 8 7.85454Z",
    fill: "#ECEDED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBg);
export default __webpack_public_path__ + "static/media/card-bg.43adad2ad474f67f4b3736b504659e71.svg";
export { ForwardRef as ReactComponent };